module.exports = __webpack_public_path__ + "img/39.d728c73b.png";